module.exports = __webpack_public_path__ + "img/leturer-logo.ba486f0d.png";